import React from 'react';
import { Link } from 'react-router-dom';
import { GET_PARAMS, GET_POPUPS } from '../../../const/router';
import usePrepareLink from '../../../hooks/usePrepareLink';

const EndOfFeedCarpet = () => {

    const advacnedSearchlink = usePrepareLink({
        pushToQuery: {
            [GET_PARAMS.popup]: GET_POPUPS.popup.advancedSearch,
        },
        keepOldQuery: true,
    });

    return (
        <li className="gallery_list_item prof" style={{ backgroundColor: 'gray' }}>
            {/* <div className="item_pict_block" style={{ backgroundColor: 'red' }}>
                <img
                    //src={"/assets/images/noPhoto.png"}
                    src="/assets/images/noPhoto.png"
                    loading="lazy"
                    alt=""
                    className="item_pict"
                />
            </div> */}
            <div className="gallery_link prof w-inline-block" style={{ textAlign: 'center', display: 'flex', justifyContent: 'center' }}>
                <h1 style={{ marginBottom: '20px' }} className="user_name">זה הכל בינתיים..</h1>
                <h4>אלה היו האנשים שהתאימו לסינון שבחרת ולהעדפות שלך.</h4>
                <h4>אפשר לשנות את הסינון באמצעות לחיצה על החץ האדום בראש המסך או לשנות מעט את ההעדפות ולהרחיב את מעגל ההיכרויות.</h4>

                <div className="gallery_prof_info status" style={{ display: 'flex', alignItems: 'center' }}>
                    <Link to={advacnedSearchlink} className="button">
                        <div>להעדפות שלי</div>
                    </Link>
                </div>
            </div>
        </li>
    )
}

export default EndOfFeedCarpet;